// -----------------------------------------------------------------------------
// Scripts for realizations gallery
// -----------------------------------------------------------------------------

$(function () {
  // Gallery sliders
  const sliders = $('.gallery-tab__content-item');

  $.each(sliders, function(index, value) {
    const singleSlider = $(this).find('.gallery-tab__slider').attr('id');

    $(`#${singleSlider}`).slick({
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      fade: true,
      arrows: true,
      dots: false
    });
  });


  // Tabs
  $('.realizations .gallery-tab__nav-link').on('click', function () {
    const selectedTabNav = $(this).parent();
    const selectedTabContent = $(this).attr('data-target');

    let activeTabNav = $('.gallery-tab__nav-item');
    let activeTabContent = $('.gallery-tab__content-item');

    if(activeTabNav && activeTabContent) {
      activeTabNav.removeClass('active');
      activeTabContent.removeClass('active');
    }

    selectedTabNav.addClass('active');
    $(selectedTabContent).addClass('active');

    $('.gallery-tab__slider').slick('setPosition'); 
  });
});